module.exports = __webpack_public_path__ + "img/ic-qr.1c68b668.svg";